import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/* Hoisted component overrides so React reconciliation stays stable. */
const MdH1 = (p) => <h3 className="text-[14px] font-semibold mt-2 mb-1" {...p} />;
const MdH2 = (p) => <h4 className="text-[13.5px] font-semibold mt-2 mb-1" {...p} />;
const MdH3 = (p) => <h5 className="text-[13px] font-semibold mt-2 mb-1" {...p} />;
const MdP = (p) => <p className="my-1.5 leading-relaxed" {...p} />;
const MdStrong = (p) => <strong className="font-semibold text-foreground" {...p} />;
const MdEm = (p) => <em className="italic" {...p} />;
const MdUl = (p) => <ul className="list-disc pl-5 my-1.5 space-y-0.5" {...p} />;
const MdOl = (p) => <ol className="list-decimal pl-5 my-1.5 space-y-0.5" {...p} />;
const MdLi = (p) => <li className="leading-relaxed" {...p} />;
const MdBlockquote = (p) => <blockquote className="border-l-2 border-gold/60 pl-3 my-2 text-muted-foreground italic" {...p} />;
const MdHr = () => <hr className="my-2 border-border" />;
const MdA = (p) => <a className="text-gold underline underline-offset-2" target="_blank" rel="noopener noreferrer" {...p} />;
const MdCode = ({ inline, className: cls, children: c, ...p }) =>
    inline ? (
        <code className="px-1 py-0.5 rounded bg-muted text-[12px] font-mono" {...p}>{c}</code>
    ) : (
        <pre className="my-2 rounded-md bg-[#0f1424] text-[#e5e7eb] p-3 overflow-x-auto text-[11.5px] font-mono leading-relaxed">
            <code {...p}>{c}</code>
        </pre>
    );
const MdTable = (p) => (
    <div className="my-2 overflow-x-auto">
        <table className="text-[12px] border-collapse w-full" {...p} />
    </div>
);
const MdTh = (p) => <th className="text-left border border-border px-2 py-1 bg-muted/40 font-semibold" {...p} />;
const MdTd = (p) => <td className="border border-border px-2 py-1 align-top" {...p} />;

const MD_COMPONENTS = {
    h1: MdH1, h2: MdH2, h3: MdH3,
    p: MdP, strong: MdStrong, em: MdEm,
    ul: MdUl, ol: MdOl, li: MdLi,
    code: MdCode, a: MdA, table: MdTable, th: MdTh, td: MdTd,
    blockquote: MdBlockquote, hr: MdHr,
};

const REMARK_PLUGINS = [remarkGfm];

/**
 * Renders Copilot markdown content with sensible defaults for our chat bubbles.
 */
export default function MarkdownMessage({ children, className = "" }) {
    return (
        <div className={`copilot-md ${className}`} data-testid="copilot-markdown">
            <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={MD_COMPONENTS}>
                {typeof children === "string" ? children : String(children ?? "")}
            </ReactMarkdown>
        </div>
    );
}
